export default "__VITE_ASSET__B5ViPP9F__"